/* Avi The Gem Guy — loads every stone's carat and measurement values for the Loose Gems range filters.
   Reads the collection's ?view=avi-range-values pages (250 stones each), keeps each value exactly as Shopify
   stores it, caches the result for the session, then exposes window.aviRangeValues and fires "avi:range-values".
   assets/loose-gems-filters.js uses these values to select every stone inside a min/max range. */
(() => {
  const root = document.querySelector('[data-avi-range-values]');
  if (!root) return;

  const baseUrl = root.dataset.url;
  const cacheKey = `avi-range-values:${baseUrl}:${root.dataset.version || ''}`;

  const publish = (values) => {
    window.aviRangeValues = values;
    document.dispatchEvent(new CustomEvent('avi:range-values', { detail: values }));
  };

  try {
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      publish(JSON.parse(cached));
      return;
    }
  } catch (e) {}

  const fetchPage = (page) =>
    fetch(`${baseUrl}${baseUrl.includes('?') ? '&' : '?'}view=avi-range-values&page=${page}`, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : Promise.reject(response.status)));

  const merge = (target, pageValues) => {
    Object.entries(pageValues || {}).forEach(([key, list]) => {
      const seen = (target[key] = target[key] || []);
      list.forEach((raw) => {
        if (raw !== '' && !seen.includes(raw)) seen.push(raw);
      });
    });
    return target;
  };

  fetchPage(1)
    .then((first) => {
      const rest = [];
      for (let page = 2; page <= first.pages; page += 1) rest.push(fetchPage(page));
      return Promise.all(rest).then((pages) => [first, ...pages]);
    })
    .then((pages) => {
      const values = pages.reduce((acc, page) => merge(acc, page.values), {});
      try { sessionStorage.setItem(cacheKey, JSON.stringify(values)); } catch (e) {}
      publish(values);
    })
    .catch(() => {});
})();
